import crel from 'crel';
import L10n from '../../l10n/index.js';
export default class ToggleButton {
    constructor(visible = true, action, enableHelpers = false) {
        this.button = null;
        this.icon = null;
        const hasTooltip = (enableHelpers) ? ({ tooltip: L10n.gettext('toggle_highlights') }) : {};
        this.button = crel('div', Object.assign({ role: 'button' }, hasTooltip));
        this.icon = crel('i', {
            class: (visible) ? 'fa fa-eye' : 'fa fa-eye-slash',
            style: 'font-size: 2em; opacity: .7;',
        });
        this.button.appendChild(this.icon);
        this.button.addEventListener('click', action);
    }
    init(view) {
        view.appendChild(this.button);
    }
    update(visibility) {
        if (visibility) {
            this.icon.classList.add('fa-eye');
            this.icon.classList.remove('fa-eye-slash');
        }
        else {
            this.icon.classList.remove('fa-eye');
            this.icon.classList.add('fa-eye-slash');
        }
    }
}
